import { useEffect, useRef } from 'react';

const PUBLISHER_ID = process.env.REACT_APP_ADSENSE_PUBLISHER_ID;

export const adsAllowed = () => {
  if (!PUBLISHER_ID) return false;
  return localStorage.getItem('officium_staff') !== '1';
};

export const AdUnit = ({ slot, format = 'auto', layoutKey, className = '' }) => {
  const holder = useRef(null);
  const pushed = useRef(false);

  useEffect(() => {
    const node = holder.current;
    if (!node || !slot || pushed.current) return undefined;
    const watcher = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting || pushed.current) return;
      pushed.current = true;
      window.adsbygoogle = window.adsbygoogle || [];
      try {
        window.adsbygoogle.push({});
        watcher.disconnect();
      } catch (error) {
        pushed.current = false;
      }
    }, { rootMargin: '250px 0px' });
    watcher.observe(node);
    return () => watcher.disconnect();
  }, [slot]);

  if (!PUBLISHER_ID || !slot) return null;

  return (
    <ins
      ref={holder}
      className={`adsbygoogle ${className}`}
      style={{ display: 'block', width: '100%', maxWidth: '100%', minHeight: 90 }}
      data-ad-client={PUBLISHER_ID}
      data-ad-slot={slot}
      data-ad-format={format}
      data-ad-layout-key={layoutKey}
      data-full-width-responsive="true"
      data-testid={`ad-unit-${slot}`}
    />
  );
};
